{
  "schema_version": 4,
  "source": "telugu_panchangam.personal.election_chart_rules.ELECTION_CHART_RULES",
  "house_system": "whole_sign",
  "node_convention": "mean",
  "vacancy_includes": [
    "Surya",
    "Chandra",
    "Kuja",
    "Budha",
    "Guru",
    "Shukra",
    "Shani",
    "Rahu",
    "Ketu"
  ],
  "convention_schema_version": 2,
  "conventions": {
    "whole-sign-physical-occupation-v1": {
      "label": "Whole Sign physical-occupation convention v1",
      "formula": "house = 1 + ((graha Rasi index - local Lagna Rasi index + 12) mod 12). “Occupies Lagna” means physical occupation of house 1; it does not mean aspect, lordship, Shadbala or Lagna strength.",
      "method_claims": [
        "election_chart.whole_sign_house_policy_v1"
      ]
    },
    "annaprasana-natural-malefic-lagna-v1": {
      "label": "Annaprasana natural-malefic Lagna convention v1",
      "formula": "Reject Surya, Kuja, Shani, mean Rahu or mean Ketu in Whole Sign house 1. When Chandra occupies house 1, let E = (Chandra longitude - Surya longitude) mod 360 degrees: 0 < E < 180 is waxing and does not fail; 180 < E < 360 is waning and fails. Return unknown within ±0.02 degrees of 0 or 180. Budha joined to a natural malefic is represented by same-sign occupation; the accompanying malefic already controls this prohibition.",
      "method_claims": [
        "election_chart.natural_malefics.bphs_3_11_modern_witness",
        "election_chart.whole_sign_house_policy_v1",
        "election_chart.mean_node_policy_v1",
        "election_chart.budha_same_sign_association_policy_v1",
        "election_chart.raman_180_degree_paksha_policy_v1",
        "election_chart.lunar_phase_boundary_guard_policy_v1",
        "election_chart.annaprasana_fail_closed_aggregation_policy_v1"
      ]
    },
    "phaladeepika-well-placed-v1": {
      "label": "Phaladeepika well-placed convention v1",
      "formula": "Outside houses 6, 8 and 12; outside an enemy Rasi; and outside debilitation Rasi or Navamsa. Chandra must also clear Surya by more than the disclosed 12-degree v1 solar-ray threshold.",
      "method_claims": [
        "election_chart.well_placed.phaladeepika_2_36",
        "election_chart.dignity.phaladeepika_1_6",
        "election_chart.relationships.phaladeepika_2_21_22",
        "election_chart.navamsa.bphs_6_12",
        "election_chart.chandra_solar_clearance_policy_v1",
        "election_chart.gold_transition_envelope_v1"
      ]
    },
    "phaladeepika-full-graha-drishti-v1": {
      "label": "Phaladeepika full Graha Drishti convention v1",
      "formula": "Every classical graha fully aspects the 7th; Kuja also the 4th and 8th, Guru the 5th and 9th, and Shani the 3rd and 10th. Rahu, Ketu and partial aspects are excluded.",
      "method_claims": [
        "election_chart.full_graha_drishti.phaladeepika_2_23",
        "election_chart.gold_transition_envelope_v1"
      ]
    },
    "vidyarambha-benefic-trio-co-location-v1": {
      "label": "Aksharabhyasa benefic-trio co-location convention v1",
      "formula": "H(Budha) = 9 AND H(Shukra) = 9 AND H(Guru) = 9. All three named grahas must occupy the ninth house in every sampled chart state; one or two matching placements do not satisfy the preference.",
      "method_claims": [
        "election_chart.vidyarambha_co_location_policy_v1",
        "election_chart.vidyarambha_reject_precedence_policy_v1"
      ]
    }
  },
  "complete_assessors": [
    "gold",
    "annaprasana",
    "karnavedha"
  ],
  "rules": {
    "wedding": [
      {
        "id": "wedding.house-7-vacant",
        "label": "7th house is vacant",
        "kind": "house_empty",
        "effect": "reject",
        "source_claim": "muhurta.wedding",
        "source_locator": "B. V. Raman, Chapter IX, 'Electing a time for marriage,' inspected in the 2020 Chistabo derivative at internal printed pp. 41-42 (physical PDF pp. 45-46), from the lunar-month paragraph through the election-chart conditions",
        "house": 7
      },
      {
        "id": "wedding.kuja-not-8",
        "label": "Mangala (Kuja) is outside the 8th house",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.wedding",
        "source_locator": "B. V. Raman, Chapter IX, 'Electing a time for marriage,' inspected in the 2020 Chistabo derivative at internal printed pp. 41-42 (physical PDF pp. 45-46), from the lunar-month paragraph through the election-chart conditions",
        "planet": "Kuja",
        "house": 8
      },
      {
        "id": "wedding.shukra-not-6",
        "label": "Shukra is outside the 6th house",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.wedding",
        "source_locator": "B. V. Raman, Chapter IX, 'Electing a time for marriage,' inspected in the 2020 Chistabo derivative at internal printed pp. 41-42 (physical PDF pp. 45-46), from the lunar-month paragraph through the election-chart conditions",
        "planet": "Shukra",
        "house": 6
      }
    ],
    "annaprasana": [
      {
        "id": "annaprasana.house-10-vacant",
        "label": "10th house is vacant",
        "kind": "house_empty",
        "effect": "reject",
        "source_claim": "muhurta.annaprasana.raman_transcription_chart",
        "source_locator": "B. V. Raman, Chapter VIII, 'First feeding on rice (Annaprasana),' inspected in the 2020 Chistabo derivative at internal printed p. 22 (physical PDF p. 25)",
        "house": 10,
        "convention_id": "whole-sign-physical-occupation-v1",
        "convention_label": "Whole Sign physical-occupation convention v1",
        "formula": "house = 1 + ((graha Rasi index - local Lagna Rasi index + 12) mod 12). “Occupies Lagna” means physical occupation of house 1; it does not mean aspect, lordship, Shadbala or Lagna strength.",
        "method_claims": [
          "election_chart.whole_sign_house_policy_v1"
        ]
      },
      {
        "id": "annaprasana.budha-not-7",
        "label": "Budha is outside the 7th house",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.annaprasana.raman_transcription_chart",
        "source_locator": "B. V. Raman, Chapter VIII, 'First feeding on rice (Annaprasana),' inspected in the 2020 Chistabo derivative at internal printed p. 22 (physical PDF p. 25)",
        "planet": "Budha",
        "house": 7,
        "convention_id": "whole-sign-physical-occupation-v1",
        "convention_label": "Whole Sign physical-occupation convention v1",
        "formula": "house = 1 + ((graha Rasi index - local Lagna Rasi index + 12) mod 12). “Occupies Lagna” means physical occupation of house 1; it does not mean aspect, lordship, Shadbala or Lagna strength.",
        "method_claims": [
          "election_chart.whole_sign_house_policy_v1"
        ]
      },
      {
        "id": "annaprasana.kuja-not-8",
        "label": "Mangala (Kuja) is outside the 8th house",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.annaprasana.raman_transcription_chart",
        "source_locator": "B. V. Raman, Chapter VIII, 'First feeding on rice (Annaprasana),' inspected in the 2020 Chistabo derivative at internal printed p. 22 (physical PDF p. 25)",
        "planet": "Kuja",
        "house": 8,
        "convention_id": "whole-sign-physical-occupation-v1",
        "convention_label": "Whole Sign physical-occupation convention v1",
        "formula": "house = 1 + ((graha Rasi index - local Lagna Rasi index + 12) mod 12). “Occupies Lagna” means physical occupation of house 1; it does not mean aspect, lordship, Shadbala or Lagna strength.",
        "method_claims": [
          "election_chart.whole_sign_house_policy_v1"
        ]
      },
      {
        "id": "annaprasana.shukra-not-9",
        "label": "Shukra is outside the 9th house",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.annaprasana.raman_transcription_chart",
        "source_locator": "B. V. Raman, Chapter VIII, 'First feeding on rice (Annaprasana),' inspected in the 2020 Chistabo derivative at internal printed p. 22 (physical PDF p. 25)",
        "planet": "Shukra",
        "house": 9,
        "convention_id": "whole-sign-physical-occupation-v1",
        "convention_label": "Whole Sign physical-occupation convention v1",
        "formula": "house = 1 + ((graha Rasi index - local Lagna Rasi index + 12) mod 12). “Occupies Lagna” means physical occupation of house 1; it does not mean aspect, lordship, Shadbala or Lagna strength.",
        "method_claims": [
          "election_chart.whole_sign_house_policy_v1"
        ]
      },
      {
        "id": "annaprasana.benefic-occupies-lagna",
        "label": "Budha, Guru or Shukra occupies Lagna",
        "kind": "any_planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.annaprasana.raman_transcription_chart",
        "source_locator": "B. V. Raman, Chapter VIII, 'First feeding on rice (Annaprasana),' inspected in the 2020 Chistabo derivative at internal printed p. 22 (physical PDF p. 25)",
        "planets": [
          "Budha",
          "Guru",
          "Shukra"
        ],
        "houses": [
          1
        ],
        "convention_id": "whole-sign-physical-occupation-v1",
        "convention_label": "Whole Sign physical-occupation convention v1",
        "formula": "house = 1 + ((graha Rasi index - local Lagna Rasi index + 12) mod 12). “Occupies Lagna” means physical occupation of house 1; it does not mean aspect, lordship, Shadbala or Lagna strength.",
        "method_claims": [
          "election_chart.whole_sign_house_policy_v1"
        ],
        "decision_policy_claim": "election_chart.annaprasana.raman_transcription_policy_v1"
      },
      {
        "id": "annaprasana.no-natural-malefic-in-lagna",
        "label": "No natural malefic occupies Lagna",
        "kind": "house_free_of_natural_malefics",
        "effect": "reject",
        "source_claim": "muhurta.annaprasana.raman_transcription_chart",
        "source_locator": "B. V. Raman, Chapter VIII, 'First feeding on rice (Annaprasana),' inspected in the 2020 Chistabo derivative at internal printed p. 22 (physical PDF p. 25)",
        "house": 1,
        "fixed_malefics": [
          "Surya",
          "Kuja",
          "Shani",
          "Rahu",
          "Ketu"
        ],
        "lunar_phase_guard_degrees": 0.02,
        "convention_id": "annaprasana-natural-malefic-lagna-v1",
        "convention_label": "Annaprasana natural-malefic Lagna convention v1",
        "formula": "Reject Surya, Kuja, Shani, mean Rahu or mean Ketu in Whole Sign house 1. When Chandra occupies house 1, let E = (Chandra longitude - Surya longitude) mod 360 degrees: 0 < E < 180 is waxing and does not fail; 180 < E < 360 is waning and fails. Return unknown within ±0.02 degrees of 0 or 180. Budha joined to a natural malefic is represented by same-sign occupation; the accompanying malefic already controls this prohibition.",
        "method_claims": [
          "election_chart.natural_malefics.bphs_3_11_modern_witness",
          "election_chart.whole_sign_house_policy_v1",
          "election_chart.mean_node_policy_v1",
          "election_chart.budha_same_sign_association_policy_v1",
          "election_chart.raman_180_degree_paksha_policy_v1",
          "election_chart.lunar_phase_boundary_guard_policy_v1",
          "election_chart.annaprasana_fail_closed_aggregation_policy_v1"
        ]
      }
    ],
    "karnavedha": [
      {
        "id": "karnavedha.house-8-vacant",
        "label": "8th house is vacant",
        "kind": "house_empty",
        "effect": "reject",
        "source_claim": "muhurta.karnavedha",
        "source_locator": "B. V. Raman, Chapter VIII, 'Ear boring (Karnavedha),' inspected in the 2020 Chistabo derivative at internal printed p. 23 (physical PDF p. 26)",
        "house": 8
      }
    ],
    "seemantha": [
      {
        "id": "seemantha.house-8-vacant",
        "label": "8th house is vacant",
        "kind": "house_empty",
        "effect": "reject",
        "source_claim": "muhurta.seemantha",
        "source_locator": "B. V. Raman, Chapter VII-VIII transition, 'Seemantha,' inspected in the 2020 Chistabo derivative at internal printed pp. 21-22 (physical PDF pp. 24-25)",
        "house": 8
      },
      {
        "id": "seemantha.chandra-not-8",
        "label": "Chandra is outside the 8th house",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.seemantha",
        "source_locator": "B. V. Raman, Chapter VII-VIII transition, 'Seemantha,' inspected in the 2020 Chistabo derivative at internal printed pp. 21-22 (physical PDF pp. 24-25)",
        "planet": "Chandra",
        "house": 8
      }
    ],
    "gruhapravesha": [
      {
        "id": "gruhapravesha.house-8-vacant",
        "label": "8th house is vacant",
        "kind": "house_empty",
        "effect": "reject",
        "source_claim": "muhurta.gruhapravesha",
        "source_locator": "B. V. Raman, Chapter XII, 'House building,' section 'Entering a new house,' inspected in the 2020 Chistabo derivative at internal printed pp. 52-54 (physical PDF pp. 56-58)",
        "house": 8
      }
    ],
    "property": [
      {
        "id": "property.guru-kendra-trikona",
        "label": "Guru occupies a Kendra or Trikona",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.land_purchase.building",
        "source_locator": "B. V. Raman, Chapter XII, 'Buying Lands for Buildings,' inspected in the 2020 Chistabo derivative at internal printed p. 54 (physical PDF p. 58)",
        "planet": "Guru",
        "houses": [
          1,
          4,
          5,
          7,
          9,
          10
        ]
      },
      {
        "id": "property.kuja-11",
        "label": "Mangala (Kuja) occupies the 11th house",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.land_purchase.building",
        "source_locator": "B. V. Raman, Chapter XII, 'Buying Lands for Buildings,' inspected in the 2020 Chistabo derivative at internal printed p. 54 (physical PDF p. 58)",
        "planet": "Kuja",
        "houses": [
          11
        ]
      },
      {
        "id": "property.kuja-not-lagna",
        "label": "Mangala (Kuja) is outside Lagna",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.land_purchase.building",
        "source_locator": "B. V. Raman, Chapter XII, 'Buying Lands for Buildings,' inspected in the 2020 Chistabo derivative at internal printed p. 54 (physical PDF p. 58)",
        "planet": "Kuja",
        "house": 1
      }
    ],
    "house_purchase": [
      {
        "id": "house-purchase.kuja-not-lagna",
        "label": "Mangala (Kuja) is outside Lagna",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.house_purchase.completed",
        "source_locator": "B. V. Raman, Chapter XII, 'Buying Houses,' inspected in the 2020 Chistabo derivative at internal printed p. 54 (physical PDF p. 58)",
        "planet": "Kuja",
        "house": 1
      }
    ],
    "gold": [
      {
        "id": "gold.surya-well-situated",
        "label": "Surya is well situated under the disclosed v1 convention",
        "kind": "planet_well_situated",
        "effect": "qualify",
        "source_claim": "muhurta.gold_jewelry.purchase",
        "source_locator": "B. V. Raman, Chapter X, 'Buying Jewelry,' inspected in the 2020 Chistabo derivative at internal printed p. 45 (physical PDF p. 49)",
        "planet": "Surya",
        "avoid_houses": [
          6,
          8,
          12
        ],
        "enemy_rashis": [
          "Vrishabha",
          "Tula",
          "Makara",
          "Kumbha"
        ],
        "debilitation_rashi": "Tula",
        "navamsa_debilitation_rashi": "Tula",
        "convention_id": "phaladeepika-well-placed-v1",
        "convention_label": "Phaladeepika well-placed convention v1",
        "formula": "Outside houses 6, 8 and 12; outside an enemy Rasi; and outside debilitation Rasi or Navamsa. Chandra must also clear Surya by more than the disclosed 12-degree v1 solar-ray threshold.",
        "method_claims": [
          "election_chart.well_placed.phaladeepika_2_36",
          "election_chart.dignity.phaladeepika_1_6",
          "election_chart.relationships.phaladeepika_2_21_22",
          "election_chart.navamsa.bphs_6_12",
          "election_chart.chandra_solar_clearance_policy_v1",
          "election_chart.gold_transition_envelope_v1"
        ],
        "decision_policy_claim": "election_chart.gold_qualification_policy_v1"
      },
      {
        "id": "gold.chandra-well-situated",
        "label": "Chandra is well situated under the disclosed v1 convention",
        "kind": "planet_well_situated",
        "effect": "qualify",
        "source_claim": "muhurta.gold_jewelry.purchase",
        "source_locator": "B. V. Raman, Chapter X, 'Buying Jewelry,' inspected in the 2020 Chistabo derivative at internal printed p. 45 (physical PDF p. 49)",
        "planet": "Chandra",
        "avoid_houses": [
          6,
          8,
          12
        ],
        "enemy_rashis": [],
        "debilitation_rashi": "Vrischika",
        "navamsa_debilitation_rashi": "Vrischika",
        "solar_clearance_degrees": 12,
        "solar_clearance_guard_degrees": 0.02,
        "convention_id": "phaladeepika-well-placed-v1",
        "convention_label": "Phaladeepika well-placed convention v1",
        "formula": "Outside houses 6, 8 and 12; outside an enemy Rasi; and outside debilitation Rasi or Navamsa. Chandra must also clear Surya by more than the disclosed 12-degree v1 solar-ray threshold.",
        "method_claims": [
          "election_chart.well_placed.phaladeepika_2_36",
          "election_chart.dignity.phaladeepika_1_6",
          "election_chart.relationships.phaladeepika_2_21_22",
          "election_chart.navamsa.bphs_6_12",
          "election_chart.chandra_solar_clearance_policy_v1",
          "election_chart.gold_transition_envelope_v1"
        ],
        "decision_policy_claim": "election_chart.gold_qualification_policy_v1"
      },
      {
        "id": "gold.surya-fully-aspected",
        "label": "Surya receives at least one full classical Graha Drishti",
        "kind": "planet_receives_full_aspect",
        "effect": "qualify",
        "source_claim": "muhurta.gold_jewelry.purchase",
        "source_locator": "B. V. Raman, Chapter X, 'Buying Jewelry,' inspected in the 2020 Chistabo derivative at internal printed p. 45 (physical PDF p. 49)",
        "planet": "Surya",
        "aspectors": [
          "Chandra",
          "Kuja",
          "Budha",
          "Guru",
          "Shukra",
          "Shani"
        ],
        "convention_id": "phaladeepika-full-graha-drishti-v1",
        "convention_label": "Phaladeepika full Graha Drishti convention v1",
        "formula": "Every classical graha fully aspects the 7th; Kuja also the 4th and 8th, Guru the 5th and 9th, and Shani the 3rd and 10th. Rahu, Ketu and partial aspects are excluded.",
        "method_claims": [
          "election_chart.full_graha_drishti.phaladeepika_2_23",
          "election_chart.gold_transition_envelope_v1"
        ],
        "decision_policy_claim": "election_chart.gold_qualification_policy_v1"
      },
      {
        "id": "gold.chandra-fully-aspected",
        "label": "Chandra receives at least one full classical Graha Drishti",
        "kind": "planet_receives_full_aspect",
        "effect": "qualify",
        "source_claim": "muhurta.gold_jewelry.purchase",
        "source_locator": "B. V. Raman, Chapter X, 'Buying Jewelry,' inspected in the 2020 Chistabo derivative at internal printed p. 45 (physical PDF p. 49)",
        "planet": "Chandra",
        "aspectors": [
          "Surya",
          "Kuja",
          "Budha",
          "Guru",
          "Shukra",
          "Shani"
        ],
        "convention_id": "phaladeepika-full-graha-drishti-v1",
        "convention_label": "Phaladeepika full Graha Drishti convention v1",
        "formula": "Every classical graha fully aspects the 7th; Kuja also the 4th and 8th, Guru the 5th and 9th, and Shani the 3rd and 10th. Rahu, Ketu and partial aspects are excluded.",
        "method_claims": [
          "election_chart.full_graha_drishti.phaladeepika_2_23",
          "election_chart.gold_transition_envelope_v1"
        ],
        "decision_policy_claim": "election_chart.gold_qualification_policy_v1"
      }
    ],
    "vidyarambha": [
      {
        "id": "vidyarambha.house-8-vacant",
        "label": "8th house is vacant",
        "kind": "house_empty",
        "effect": "reject",
        "source_claim": "muhurta.vidyarambha",
        "source_locator": "B. V. Raman, Chapter VIII, 'Commencing education (Aksharabhyasa),' inspected in the 2020 Chistabo derivative at internal printed p. 23 (physical PDF p. 26)",
        "house": 8
      },
      {
        "id": "vidyarambha.budha-shukra-guru-9",
        "label": "Budha, Shukra and Guru are all in the 9th house",
        "kind": "all_planets_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.vidyarambha",
        "source_locator": "B. V. Raman, Chapter VIII, 'Commencing education (Aksharabhyasa),' inspected in the 2020 Chistabo derivative at internal printed p. 23 (physical PDF p. 26)",
        "planets": [
          "Budha",
          "Shukra",
          "Guru"
        ],
        "houses": [
          9
        ],
        "convention_id": "vidyarambha-benefic-trio-co-location-v1",
        "convention_label": "Aksharabhyasa benefic-trio co-location convention v1",
        "formula": "H(Budha) = 9 AND H(Shukra) = 9 AND H(Guru) = 9. All three named grahas must occupy the ninth house in every sampled chart state; one or two matching placements do not satisfy the preference.",
        "method_claims": [
          "election_chart.vidyarambha_co_location_policy_v1",
          "election_chart.vidyarambha_reject_precedence_policy_v1"
        ],
        "decision_policy_claim": "election_chart.vidyarambha_reject_precedence_policy_v1"
      }
    ],
    "purchase": [
      {
        "id": "purchase.chandra-lagna",
        "label": "Chandra occupies Lagna",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.purchase.general",
        "source_locator": "Nakshatra-prakarana, purchase Muhurta verse 16, printed pp. 33-34, and marketplace verse 17, printed pp. 34-35",
        "planet": "Chandra",
        "houses": [
          1
        ]
      },
      {
        "id": "purchase.shukra-lagna",
        "label": "Shukra occupies Lagna",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.purchase.general",
        "source_locator": "Nakshatra-prakarana, purchase Muhurta verse 16, printed pp. 33-34, and marketplace verse 17, printed pp. 34-35",
        "planet": "Shukra",
        "houses": [
          1
        ]
      }
    ],
    "job": [
      {
        "id": "job.surya-or-kuja-10-11",
        "label": "Surya or Mangala (Kuja) occupies the 10th or 11th house",
        "kind": "any_planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.service_entry",
        "source_locator": "Nakshatra-prakarana, 'Entering the service of a master,' verse 26, printed p. 38",
        "planets": [
          "Surya",
          "Kuja"
        ],
        "houses": [
          10,
          11
        ]
      }
    ],
    "ceremony": [
      {
        "id": "ceremony.surya-10",
        "label": "Surya occupies the 10th house",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.shantika_paushtika",
        "source_locator": "Nakshatra-prakarana, 'Shantika and Paushtika Muhurta,' verse 34, printed pp. 42-43",
        "planet": "Surya",
        "houses": [
          10
        ]
      },
      {
        "id": "ceremony.chandra-4",
        "label": "Chandra occupies the 4th house",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.shantika_paushtika",
        "source_locator": "Nakshatra-prakarana, 'Shantika and Paushtika Muhurta,' verse 34, printed pp. 42-43",
        "planet": "Chandra",
        "houses": [
          4
        ]
      },
      {
        "id": "ceremony.guru-lagna",
        "label": "Guru occupies Lagna",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.shantika_paushtika",
        "source_locator": "Nakshatra-prakarana, 'Shantika and Paushtika Muhurta,' verse 34, printed pp. 42-43",
        "planet": "Guru",
        "houses": [
          1
        ]
      }
    ],
    "pilgrimage": [
      {
        "id": "pilgrimage.guru-lagna-or-9",
        "label": "Guru occupies Lagna or the 9th house",
        "kind": "planet_in_houses",
        "effect": "prefer",
        "source_claim": "muhurta.pilgrimage",
        "source_locator": "B. V. Raman, Chapter XIV, 'Journeys' and 'Pilgrimage,' inspected in the 2020 Chistabo derivative at internal printed pp. 60-62 (physical PDF pp. 64-66)",
        "planet": "Guru",
        "houses": [
          1,
          9
        ]
      }
    ],
    "travel": [
      {
        "id": "travel.kuja-not-8",
        "label": "Mangala (Kuja) is outside the 8th house",
        "kind": "planet_not_house",
        "effect": "reject",
        "source_claim": "muhurta.travel",
        "source_locator": "B. V. Raman, Chapter XIV, 'Journeys' and 'Long-distance Journeys,' inspected in the 2020 Chistabo derivative at internal printed pp. 60-61 (physical PDF pp. 64-65)",
        "planet": "Kuja",
        "house": 8
      }
    ],
    "surgery": [
      {
        "id": "surgery.house-8-vacant",
        "label": "8th house is vacant",
        "kind": "house_empty",
        "effect": "reject",
        "source_claim": "muhurta.surgery",
        "source_locator": "B. V. Raman, Chapter XV, 'Surgical Operations,' inspected in the 2020 Chistabo derivative at internal printed pp. 64-65 (physical PDF pp. 68-69)",
        "house": 8
      }
    ]
  },
  "manual_remainders": {
    "wedding": [
      "Assess malefic occupancy or hemming around Lagna and any Chandra-Graha association.",
      "Review the optional fortification combinations and both partners’ compatibility, Tarabala, Chandrabala and Panchaka."
    ],
    "annaprasana": [],
    "karnavedha": [],
    "seemantha": [
      "If relying on Pournami, assess the source’s qualitative Chandra-dignity condition."
    ],
    "gruhapravesha": [
      "Assess Guru, Shukra and Chandra strength, benefic/malefic placement, rising-Rasi ownership and the Navamsa exception."
    ],
    "property": [
      "Assess the weekday lord in Lagna, harmony between Lagna and 7th lords, and whether the 11th lord occupies the 12th."
    ],
    "house_purchase": [
      "Assess whether a malefic occupies the 7th house."
    ],
    "gold": [],
    "vidyarambha": [],
    "purchase": [
      "Keep malefics outside the 8th and 12th houses, and assess whether benefics occupy the 2nd, 10th or 11th."
    ],
    "job": [
      "Assess whether a benefic strengthens Lagna and complete the employer/employee compatibility checks."
    ],
    "ceremony": [
      "Assess combustion, exceptional omens and whether the remedial-urgency exception applies."
    ],
    "pilgrimage": [],
    "travel": [
      "Assess general Lagna fortification, whether Guru or Shukra is well placed in Lagna, waxing Chandra and malefic occupancy of the 7th house."
    ],
    "surgery": [
      "Assess the operated-body-part Rasi and house, malefic affliction, Mangala strength and Mangala-Shani aspects."
    ]
  }
}
